// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"2a5a37cd","25":"6fa68822","60":"f6b7584b","173":"84734e10","425":"d1675fad","758":"2afc81d9","871":"59441039","872":"b642b9e1"}[chunkId] + ".chunk.js";
};